// eslint-disable-next-line import/prefer-default-export
export const isMobilePlatform =
  navigator.userAgent.includes('Android') ||
  navigator.userAgent.includes('iPad') ||
  navigator.userAgent.includes('iPhone')
